module.exports = __webpack_public_path__ + "img/jkr.9058e04c.jpg";